import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { Documento } from 'src/app/model/documenti/Documento';
import { DocumentiService } from 'src/app/services/documenti/documenti.service';
import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';
import { patchCss } from '../../functions/ovverideCss';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
  @Input() set idNonConformita(value: number) {
    if (value != this._idNonConformita) {
      this._idNonConformita = value;
    }
  }

  @Input() set numeroOrdine(value: string) {
    if (value != this._numeroOrdine) {
      this._numeroOrdine = value;
    }
  }

  _numeroOrdine: string;
  @Input() set docFirst(value: number) {
    if (value != this._first) {
      this._first = value;
    }
  }
  @Input() set docLength(value: number) {
    if (value != this._length) {
      this._length = value;
    }
  }

  @Input() set isTeamView(value: boolean) {
    if (!CommonUtils.isNotNullOrUndefined(this._isTeamView)) {
      this._isTeamView = value;
    } else if (value != this._isTeamView) {
      this._isTeamView = value;
      this.getDocumenti();
    }
  }

  @Input() set idPosizione(value: string) {
    if (value !== this._idPosizione) {
      this._idPosizione = value;
    }
  }
  private _idPosizione: string;

  _idNonConformita: number;
  documentsDownloadComplete: boolean;
  documentiPresenti: boolean;
  erroreGestitoMex: String = null;
  srverError: boolean;
  documenti: Documento[];
  expandedElement: string[] = [];
  ordiniDetails: {};
  _isTeamView: boolean;
  elementiPerPagina = AppConstants.DOCUMENTI_PER_PAGINA;
  totaleDocumenti: number;
  serverError: boolean;
  _first: number;
  _length: number;
  cols: number;
  getEliminati: boolean = false;

  constructor(
    private documentiServ: DocumentiService,
    private router: Router
  ) {}

  ngOnInit() {
    // this.patchTable();
    if (!CommonUtils.isEmpty(this._numeroOrdine)) {
      this._numeroOrdine = null;
    }
    if (!CommonUtils.isEmpty(this._idNonConformita)) {
      this._idNonConformita = null;
    }

    if (this._idNonConformita != null) {
      this.getDocumentiperNC();
    } else {
      this.getDocumenti();
    }
  }
  getDocumenti() {
    this.documentsDownloadComplete = false;
    this.documentiPresenti = false;
    this.erroreGestitoMex = null;
    this.serverError = false;
    this.documenti = [];
    this.documentiServ
      .getDocumenti(
        this._isTeamView,
        this._first,
        this._length,
        null,
        this._numeroOrdine,
        null,
        this.getEliminati,
        null,
        null,
        this._idPosizione,
        null,
        null
      )
      .pipe(first())
      .subscribe(
        res => {
          if (res['errorMex'] != null) {
            this.erroreGestitoMex = res['errorMex'];
          } else {
            this.documenti = res['respObj'];
            this.cols = this.documenti.length;
            if (this.documenti.length > 0) {
              this.documentiPresenti = true;
            } else {
              this.documentiPresenti = false;
            }
          }
          this.documentsDownloadComplete = true;
        },
        err => {
          this.serverError = true;
          console.error('Error catch', err);
          this.documentsDownloadComplete = true;
        }
      );
  }

  getDocumentiperNC() {
    this.documentsDownloadComplete = false;
    this.documentiPresenti = false;
    this.erroreGestitoMex = null;
    this.serverError = false;
    this.documenti = [];

    this.documentiServ
      .getListaDocumentiPerNC(
        this._isTeamView,
        this._first,
        this._length,
        this._idNonConformita,
        this.getEliminati
      )
      .pipe(first())
      .subscribe(
        res => {
          if (res['errorMex'] != null) {
            this.erroreGestitoMex = res['errorMex'];
          } else {
            this.documenti = res['respObj'];
            this.cols = this.documenti.length;
            if (this.documenti.length > 0) {
              this.documentiPresenti = true;
            } else {
              this.documentiPresenti = false;
            }
          }
          this.documentsDownloadComplete = true;
        },
        err => {
          this.serverError = true;
          console.error('Error catch', err);
          this.documentsDownloadComplete = true;
        }
      );
  }

  goToDocumenti() {
    this.router.navigate([AppConstants.DOCUMENTS_ROUTE], {
      state: {
        numeroOrdine: this._numeroOrdine,
        codicePosizione: this._idPosizione,
      },
    });
  }
}
